import { render, staticRenderFns } from "./PopOrderWuliu.vue?vue&type=template&id=06e07e2a&scoped=true&"
import script from "./PopOrderWuliu.vue?vue&type=script&lang=js&"
export * from "./PopOrderWuliu.vue?vue&type=script&lang=js&"
import style0 from "./PopOrderWuliu.vue?vue&type=style&index=0&id=06e07e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e07e2a",
  null
  
)

export default component.exports